"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
require("core-js/modules/es7.symbol.async-iterator");
require("core-js/modules/es6.symbol");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.array.from");
require("core-js/modules/es6.regexp.to-string");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _typeof2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/typeof.js"));
require("core-js/modules/es6.string.starts-with");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/web.dom.iterable");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _communityComment = require("@/api/community/communityComment");
var _popupConfig = require("@/api/popup/popupConfig");
var _gradeInfo = require("@/api/basic/gradeInfo");
var _memberManagement = require("@/api/member/memberManagement");
var _DetailView = _interopRequireDefault(require("../DetailView.vue"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'CommunityDynamicsList',
  components: {
    CommunityDynamicsDetail: _DetailView.default
  },
  data: function data() {
    return {
      tableLoading: false,
      tableData: [],
      selectedRows: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      // 门店列表数据
      shopList: [],
      // 等级列表数据
      gradeList: [],
      searchForm: {
        type: 0,
        // 确保默认值为数字0
        phone: '',
        alias: '',
        timeRange: [],
        recommend: null,
        topicMessage: '',
        contentMessage: '',
        // 添加门店ID搜索条件
        shopId: null,
        // 添加等级ID搜索条件
        gradeId: null
        // 注意：不包含orderByPraise参数，因为这是社区动态列表页面
      },
      dialogVisible: false,
      banDialogVisible: false,
      // 禁言对话框可见性
      dialogForm: {
        isTop: 0,
        timeRange: [],
        startTime: '',
        endTime: '',
        ordno: '',
        adv: ''
      },
      banForm: {
        id: null,
        mobilePhone: '',
        timeRange: [],
        startTime: '',
        endTime: '',
        reason: ''
      },
      imagePrefix: '',
      exportLoading: false
    };
  },
  mounted: function mounted() {
    this.fetchData();
    // 获取门店列表
    this.getShopList();
    // 获取等级列表
    this.getGradeList();
    // 获取图片前缀
    this.fetchImagePrefix();
  },
  methods: {
    // 获取门店列表
    getShopList: function () {
      var _getShopList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response, shopList, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return (0, _popupConfig.getShops)();
            case 1:
              response = _context.sent;
              if (response.code === 200 && response.data) {
                // 转换门店数据格式为平铺列表结构，只包含门店名称和ID
                shopList = [];
                response.data.forEach(function (region) {
                  if (region.children && region.children.length > 0) {
                    region.children.forEach(function (shop) {
                      shopList.push({
                        value: shop.storeId,
                        label: shop.shopName
                      });
                    });
                  }
                });
                this.shopList = shopList;
              } else {
                this.$message.error('获取门店列表失败: ' + (response.message || '未知错误'));
              }
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              console.error('获取门店列表错误：', _t);
              this.$message.error('获取门店列表失败: ' + _t.message);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getShopList() {
        return _getShopList.apply(this, arguments);
      }
      return getShopList;
    }(),
    // 获取等级列表
    getGradeList: function () {
      var _getGradeList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var response, _t2;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 1;
              return (0, _gradeInfo.xyRuleVipGradeSelPage)({
                page: 1,
                limit: 100
              });
            case 1:
              response = _context2.sent;
              if (response.code === 200 && response.records) {
                this.gradeList = response.records;
              } else {
                this.$message.error('获取等级列表失败: ' + (response.message || '未知错误'));
              }
              _context2.next = 3;
              break;
            case 2:
              _context2.prev = 2;
              _t2 = _context2["catch"](0);
              console.error('获取等级列表错误：', _t2);
              this.$message.error('获取等级列表失败: ' + _t2.message);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function getGradeList() {
        return _getGradeList.apply(this, arguments);
      }
      return getGradeList;
    }(),
    // 根据shopId获取门店名称
    getShopName: function getShopName(shopId) {
      if (!shopId) return '';
      var _iterator = _createForOfIteratorHelper(this.shopList),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var shop = _step.value;
          if (shop.value === shopId) {
            return shop.label;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return '';
    },
    // 标签页切换
    handleTabChange: function handleTabChange() {
      this.currentPage = 1; // 重置为第一页
      this.fetchData();
    },
    fetchData: function fetchData() {
      var _this = this;
      this.tableLoading = true;
      var query = _objectSpread({
        page: this.currentPage,
        limit: this.pageSize,
        type: this.searchForm.type
      }, this.searchForm);

      // 处理时间范围参数
      if (this.searchForm.timeRange && this.searchForm.timeRange.length === 2) {
        query.startTime = this.searchForm.timeRange[0];
        query.endTime = this.searchForm.timeRange[1];
      }

      // 删除不需要的参数
      delete query.timeRange;
      (0, _communityComment.listCommentPage)(query).then(function (response) {
        if (response.code === 200) {
          _this.tableData = response.records || [];
          _this.total = response.total || 0;
        } else {
          _this.$message.error(response.message || '获取数据失败');
        }
      }).catch(function (error) {
        _this.$message.error('获取数据失败: ' + error.message);
      }).finally(function () {
        _this.tableLoading = false;
      });
    },
    handleSelectionChange: function handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.fetchData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchData();
    },
    handleSearch: function handleSearch() {
      this.currentPage = 1;
      this.fetchData();
    },
    // 查看详情
    handleViewDetail: function handleViewDetail(row) {
      // 触发事件，让父组件处理详情页展示
      this.$emit('view-detail', row, this.searchForm.type);
    },
    handleToggleRecommend: function handleToggleRecommend(row) {
      var _this2 = this;
      var newRecommend = row.isTj ? 0 : 1;
      (0, _communityComment.toggleRecommend)(row.id, newRecommend).then(function (response) {
        if (response.code === 200) {
          _this2.$message.success('推荐状态更新成功');
          row.isTj = !row.isTj;
        } else {
          _this2.$message.error(response.message || '推荐状态更新失败');
        }
      }).catch(function (error) {
        _this2.$message.error('推荐状态更新失败: ' + error.message);
      });
    },
    // 移除评论
    handleRemove: function handleRemove(row) {
      var _this3 = this;
      this.$confirm('确定要移除该评论吗？', '提示', {
        confirmButtonText: '确定移除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _communityComment.deleteComment)(row.id).then(function (response) {
          if (response.code === 200) {
            _this3.$message.success('移除成功');
            _this3.fetchData();
          } else {
            _this3.$message.error(response.message || '移除失败');
          }
        });
      }).catch(function () {
        _this3.$message.info('已取消移除');
      });
    },
    // 处理广场/审核操作
    handleAuditOrRecommend: function handleAuditOrRecommend(row, type) {
      var _this4 = this;
      // type = 1 广场，type = 2 审核
      (0, _communityComment.userContentCommentsAudit)(row.id, type).then(function (response) {
        if (response.code === 200) {
          _this4.$message.success('操作成功');
          // 更新对应字段
          if (type === 1) {
            // 广场操作，更新isTj字段
            row.isTj = !row.isTj;
          } else if (type === 2) {
            // 审核操作，更新status字段
            row.status = row.status === 1 ? 0 : 1;
          }
          // 重新加载数据
          _this4.fetchData();
        } else {
          _this4.$message.error(response.message || '操作失败');
        }
      }).catch(function (error) {
        _this4.$message.error('操作失败: ' + error.message);
      });
    },
    // 禁言按钮点击事件
    handleDelete: function handleDelete(row) {
      // 初始化禁言表单数据
      this.banForm = {
        userId: row.userId,
        // 用户ID
        mobilePhone: row.mobilePhone,
        cid: row.id,
        timeRange: [],
        startTime: '',
        endTime: '',
        reason: ''
      };
      // 显示禁言对话框
      this.banDialogVisible = true;
    },
    // 保存禁言信息
    handleSaveBan: function handleSaveBan() {
      var _this5 = this;
      // 处理时间范围
      if (this.banForm.timeRange && this.banForm.timeRange.length === 2) {
        this.banForm.startTime = new Date(this.banForm.timeRange[0]).getTime();
        this.banForm.endTime = new Date(this.banForm.timeRange[1]).getTime();
      }

      // 构造禁言请求参数
      var requestData = {
        userId: this.banForm.userId,
        startTime: this.banForm.startTime,
        endTime: this.banForm.endTime,
        reason: this.banForm.reason,
        cid: this.banForm.cid
      };

      // 调用禁言接口
      (0, _communityComment.userProhibitedSpeech)(requestData).then(function (response) {
        if (response.code === 200) {
          _this5.$message.success('禁言设置成功');
          _this5.banDialogVisible = false;
          _this5.fetchData(); // 重新加载数据
        } else {
          _this5.$message.error(response.message || '禁言设置失败');
        }
      }).catch(function (error) {
        _this5.$message.error('禁言设置失败: ' + error.message);
      });
    },
    // 取消禁言
    handleCancelBan: function handleCancelBan() {
      this.banDialogVisible = false;
    },
    handleBatchDelete: function handleBatchDelete() {
      var _this6 = this;
      this.$confirm('确定要删除选中的评论吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var ids = _this6.selectedRows.map(function (item) {
          return item.id;
        });
        (0, _communityComment.batchDeleteComment)(ids).then(function (response) {
          if (response.code === 200) {
            _this6.$message.success('删除成功');
            _this6.fetchData();
          } else {
            _this6.$message.error(response.message || '删除失败');
          }
        }).catch(function (error) {
          _this6.$message.error('删除失败: ' + error.message);
        });
      }).catch(function () {
        _this6.$message.info('已取消删除');
      });
    },
    // 获取打标状态显示名称
    getIsTopDisplayName: function getIsTopDisplayName(isTop) {
      switch (isTop) {
        case 0:
          return '未打标';
        case 1:
          return '置顶';
        case 2:
          return '广告';
        case 3:
          return '官方';
        default:
          return '未打标';
      }
    },
    // 获取打标状态按钮类型
    getIsTopButtonType: function getIsTopButtonType(isTop) {
      switch (isTop) {
        case 0:
          return 'info';
        // 未打标
        case 1:
          return 'success';
        // 置顶
        case 2:
          return 'warning';
        // 广告
        case 3:
          return 'danger';
        // 官方
        default:
          return 'info';
      }
    },
    // 打标状态按钮点击事件
    handleIsTopClick: function handleIsTopClick(row) {
      this.dialogForm = _objectSpread({}, row);
      this.dialogVisible = true;
    },
    // 对话框关闭事件
    handleDialogClose: function handleDialogClose(done) {
      this.$confirm('确认关闭？').then(function (_) {
        done();
      }).catch(function (_) {});
    },
    // 保存打标信息
    handleSaveTagging: function handleSaveTagging() {
      var _this7 = this;
      // 处理时间范围
      if (this.dialogForm.timeRange && this.dialogForm.timeRange.length === 2) {
        this.dialogForm.startTime = this.dialogForm.timeRange[0];
        this.dialogForm.endTime = this.dialogForm.timeRange[1];
      }
      var param = {
        id: this.dialogForm.id,
        startTime: new Date(this.dialogForm.startTime).getTime(),
        endTime: new Date(this.dialogForm.endTime).getTime(),
        adv: this.dialogForm.adv,
        ordno: this.dialogForm.ordno,
        isTop: this.dialogForm.isTop
      };

      // 调用API更新社区评论
      (0, _communityComment.updateComment)(param).then(function (response) {
        if (response.code === 200) {
          _this7.$message.success('打标信息保存成功');
          _this7.dialogVisible = false;
          _this7.fetchData(); // 重新加载数据
        } else {
          _this7.$message.error(response.message || '保存失败');
        }
      }).catch(function (error) {
        _this7.$message.error('保存失败: ' + error.message);
      });
    },
    // 获取图片前缀
    fetchImagePrefix: function () {
      var _fetchImagePrefix = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var response, _t3;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 1;
              return (0, _memberManagement.getImagePrefix)();
            case 1:
              response = _context3.sent;
              if (response.code === 200 && response.data) {
                this.imagePrefix = response.data;
              }
              _context3.next = 3;
              break;
            case 2:
              _context3.prev = 2;
              _t3 = _context3["catch"](0);
              console.error('获取图片前缀失败:', _t3);
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function fetchImagePrefix() {
        return _fetchImagePrefix.apply(this, arguments);
      }
      return fetchImagePrefix;
    }(),
    // 获取完整图片URL
    getImageUrl: function getImageUrl(imgPath) {
      // 如果已经是完整URL，则直接返回
      if (imgPath && (imgPath.startsWith('http://') || imgPath.startsWith('https://'))) {
        return imgPath;
      }
      // 使用动态获取的图片前缀
      return imgPath ? this.imagePrefix + imgPath : '';
    },
    isUserBanned: function isUserBanned(disStartTime, disEndTime) {
      var now = new Date().getTime();
      return disStartTime && disEndTime && now >= disStartTime && now <= disEndTime;
    },
    handleExport: function handleExport() {
      var _this8 = this;
      this.exportLoading = true;
      var query = _objectSpread({
        type: this.searchForm.type
      }, this.searchForm);

      // 处理时间范围参数
      if (this.searchForm.timeRange && this.searchForm.timeRange.length === 2) {
        query.startTime = this.searchForm.timeRange[0];
        query.endTime = this.searchForm.timeRange[1];
      }

      // 删除不需要的参数
      delete query.timeRange;

      // 调用导出接口
      (0, _communityComment.exportComment)(query).then(function (response) {
        // 统一处理响应，无论是成功还是失败
        if (response && (0, _typeof2.default)(response) === 'object' && response.hasOwnProperty('code')) {
          if (response.code === 200) {
            _this8.$message.success(response.message || '导出成功，请到导出日志下载');
          }
        }
      }).catch(function (error) {
        // 只处理网络错误或其他异常情况
        console.error('导出失败:', error);
      }).finally(function () {
        _this8.exportLoading = false;
      });
    },
    // 移除详情标签页
    removeDetailTab: function removeDetailTab(targetName) {
      var tabs = this.detailTabs;
      var activeName = this.activeDetailTab;
      if (activeName === targetName) {
        tabs.forEach(function (tab, index) {
          if (tab.name === targetName) {
            var nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
            }
          }
        });
      }
      this.activeDetailTab = activeName === targetName ? 'list' : activeName;
      this.detailTabs = tabs.filter(function (tab) {
        return tab.name !== targetName;
      });
    }
  }
};